<template>
  <v-container fluid grid-list-md pl-0 pt-2 class="grey lighten-2">
    <v-toolbar class="py-2 mb-1">
      <v-avatar class="secondary">
        <v-icon dark>bar_chart</v-icon>
      </v-avatar>
      <div class="ml-3">
        <h4 class="headline">Enquiry Stats</h4>
      </div>

      <v-spacer></v-spacer>

      <v-menu
        ref="menu"
        :close-on-content-click="false"
        v-model="showStartDatePicker"
        transition="scale-transition"
        offset-y
        full-width
        :nudge-right="40"
        min-width="290px"
        :return-value.sync="startDate"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            label="Start date"
            v-model="startDateUK"
            prepend-icon="event"
            hide-details
            readonly
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="startDate"
          @input="$refs.menu.save(startDate)"
          min="2016-06-20"
          :max="endDate"
          first-day-of-week="1"
        ></v-date-picker>
      </v-menu>
      <v-menu
        ref="menu2"
        :close-on-content-click="false"
        v-model="showEndDatePicker"
        transition="scale-transition"
        offset-y
        full-width
        :nudge-right="40"
        min-width="290px"
        :return-value.sync="endDate"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            label="End date"
            v-model="endDateUK"
            prepend-icon="event"
            hide-details
            readonly
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="endDate"
          @input="$refs.menu2.save(endDate)"
          :min="startDate"
          :max="today"
          first-day-of-week="1"
        ></v-date-picker>
      </v-menu>

      <v-toolbar-items>
        <v-btn text @click="getData" :loading="DashboardDataLoading">Apply</v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-layout wrap>
      <v-flex xs12 sm6 lg3>
        <EnquiryStageCard :enquiries="DashboardFunderEnquiryBreakdown" />
      </v-flex>
      <v-flex xs12 sm6 lg3>
        <FunderOfferCard :enquiries="DashboardFunderEnquiryBreakdown" />
      </v-flex>
      <v-flex xs12 sm6 lg3>
        <SMEOfferCard :enquiries="DashboardFunderEnquiryBreakdown" />
      </v-flex>
      <v-flex xs12 sm6 lg3>
        <FundingReleasedCard :enquiries="DashboardFunderEnquiryBreakdown" :amount-funded="DashboardFunderValueFunded" />
      </v-flex>
    </v-layout>

    <v-layout wrap>
      <v-flex md12>
        <v-card>
          <v-card-title primary-title>
            <div>
              <h3 class="headline mb-0">Monthly Enquiries</h3>
              <div class="subtitle-1">For all enquiries added to date</div>
            </div>
          </v-card-title>
          <div class="pa-3">
            <BarChart :chartData="DashboardFunderEnquiriesByMonth" />
          </div>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
import BarChart from './BarChart';
import EnquiryStageCard from './EnquiryStageCard';
import FunderOfferCard from './FunderOfferCard';
import SMEOfferCard from './SMEOfferCard';
import FundingReleasedCard from './FundingReleasedCard';

const DATE_FORMAT = 'YYYY-MM-DD';

export default {
  name: 'FunderStatsView',
  components: {
    FundingReleasedCard,
    SMEOfferCard,
    FunderOfferCard,
    EnquiryStageCard,
    BarChart
  },
  props: {
    partnerId: String
  },
  data: () => ({
    startDate: moment()
      .subtract(30, 'days')
      .format(DATE_FORMAT),
    endDate: moment().format(DATE_FORMAT),
    today: moment().format(DATE_FORMAT),
    showStartDatePicker: false,
    showEndDatePicker: false
  }),
  computed: {
    ...mapGetters([
      'DashboardDataLoading',
      'DashboardFunderValueFunded',
      'DashboardFunderEnquiryBreakdown',
      'DashboardFunderEnquiriesByMonth'
    ]),
    startDateUK: function() {
      return moment(this.startDate).format('DD/MM/YYYY');
    },
    endDateUK: function() {
      return moment(this.endDate).format('DD/MM/YYYY');
    }
  },
  methods: {
    getData: function() {
      this.$store.dispatch('getFunderDashboardData', {
        startDate: this.startDate,
        endDate: this.endDate
      });
    },
    getSplitStats(statName, formatAsCurrency = false) {
      let subAccountStat = null;

      const mainStat = formatAsCurrency
        ? this.$options.filters.currency(this.DashboardPartnerStats[statName])
        : this.DashboardPartnerStats[statName];

      if (this.DashboardPartnerHasSubAccounts) {
        subAccountStat = formatAsCurrency
          ? this.$options.filters.currency(this.DashboardPartnerSubAccountStats[statName])
          : this.DashboardPartnerSubAccountStats[statName];
      }

      return this.DashboardPartnerHasSubAccounts ? `${mainStat} (${subAccountStat})` : mainStat;
    }
  },
  watch: {
    partnerId() {
      this.getData();
    }
  },
  created() {
    this.getData();
  }
};
</script>

<style type="scss" scoped>
.chart-card {
  padding: 2em;
}

.v-card__title .v-text-field {
  padding-top: 0;
}
</style>
